import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { useState } from 'react';
import { useTenantId } from '../../../Delivery/_shared/hooks/useTenantId';
import { PricingSheetIngestProgress } from '../../../Delivery/Registries/PricingSheetIngestProgress';
import { PricingSheetUploadDialog } from '../../../Delivery/Registries/PricingSheetUploadDialog';
import { useActiveIngests } from '../../../Delivery/Registries/useActiveIngests';
import { useCanUploadPricingSheet } from '../../../Delivery/Registries/usePricingSheetUploadGate';
import { AddHearsayDialog } from '../../hearsay/AddHearsayDialog';
import { useIntelClaims } from '../../hearsay/hooks';
import { intelClaimsSection } from '../../hearsay/IntelClaimsRailSection';
export function useCompanyIntel(id, name) {
    const query = useIntelClaims({
        kind: 'COMPANY',
        id
    });
    const [open, setOpen] = useState(false);
    const section = intelClaimsSection(query.data?.claims ?? [], {
        canCreate: false,
        onAdd: ()=>setOpen(true)
    });
    if (query.isError) section.children = /*#__PURE__*/ _jsx(SpecraButton, {
        variant: "ghost",
        onClick: ()=>void query.refetch(),
        children: "Retry loading intel"
    });
    else if (query.isPending) section.children = 'Loading intel…';
    return {
        section,
        action: query.data?.canCreate ? /*#__PURE__*/ _jsx(SpecraButton, {
            "data-testid": Testids.registryCompany.addHearsay,
            variant: "secondary",
            onClick: ()=>setOpen(true),
            children: "Add hearsay"
        }) : null,
        dialog: /*#__PURE__*/ _jsx(AddHearsayDialog, {
            open: open,
            onOpenChange: setOpen,
            defaultLinks: [
                {
                    linkRole: 'ABOUT',
                    targetKind: 'COMPANY',
                    targetId: id,
                    label: name,
                    locked: true
                }
            ],
            canCreateKinds: query.data?.canCreateKinds
        })
    };
}
export function CompanyUpload({ id, name, onSettled }) {
    const canUpload = useCanUploadPricingSheet();
    const tenantId = useTenantId();
    const { runs, track, untrack } = useActiveIngests(tenantId);
    const [open, setOpen] = useState(false);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            canUpload && /*#__PURE__*/ _jsx(SpecraButton, {
                variant: "secondary",
                "data-testid": Testids.registryCompany.uploadSheet,
                onClick: ()=>setOpen(true),
                children: "Upload pricing sheet"
            }),
            /*#__PURE__*/ _jsx(PricingSheetUploadDialog, {
                open: open,
                onOpenChange: setOpen,
                onStarted: track,
                expectedCompanyId: id,
                expectedCompanyName: name
            }),
            runs.map((r)=>/*#__PURE__*/ _jsx(PricingSheetIngestProgress, {
                    filename: r.filename,
                    runId: r.runId,
                    onSettled: ()=>{
                        untrack(r.runId);
                        onSettled();
                    }
                }, r.runId))
        ]
    });
}
